
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name complaints.controller:ComplaintsCtrl
     *
     * @description
     *
     */
    angular
        .module('cards')
        .controller('CardSettingsCtrl', CardSettingsCtrl);

    function CardSettingsCtrl($q, $scope, $state, HelperService, CardsService, $stateParams) {

        var vm = this;

        vm.initialValue = null;
        vm.card = null;
        vm.limitTypes = [
            { type: 'ATM', disabled: true, changed: false },
            { type: 'POS', disabled: true, changed: false },
            { type: 'Other', disabled: true, changed: false }
        ];
        vm.limitTypeChangeInProgress = false;
        vm.step = 1;

        vm.changeLimit = function(limitType) {
            vm.limitTypeChangeInProgress = true;
            limitType.previousAmount = vm.card['limitAmount' + limitType.type];
            limitType.previousTrnNo = vm.card['limitTrnNo' + limitType.type];
            limitType.disabled = false;
        }

        vm.closeLimit = function(limitType) {
            vm.card['limitAmount' + limitType.type] = limitType.previousAmount;
            vm.card['limitTrnNo' + limitType.type] = limitType.previousTrnNo;
            limitType.disabled = true;
            vm.limitTypeChangeInProgress = false;
        }

        vm.confirmLimit = function(limitType) {
            calculateIfChanged(limitType);
            limitType.disabled = true;
            vm.limitTypeChangeInProgress = false;
        }

        vm.acceptChanges = function() {
            vm.request = {};
            if (vm.initialValue.isBlocked != vm.card.isBlocked) {
                vm.request.blockCard = vm.card.isBlocked;
            }

            if (vm.initialValue.onlineShoppingIsActive != vm.card.onlineShoppingIsActive) {
                vm.request.onlineShoppingIsActive = vm.card.onlineShoppingIsActive;
            }

            vm.limitTypes.forEach(function(limitType) {
                if (limitType.changed) {
                    var amountLabel = 'limitAmount' + limitType.type;
                    var trnNoLabel = 'limitTrnNo' + limitType.type;
                    var limitLabel = 'limit' + limitType.type;
                    vm.request[amountLabel] = vm.card[amountLabel];
                    vm.request[trnNoLabel] = vm.card[trnNoLabel];
                    vm.request[limitLabel] = vm.card[limitLabel];
                }
            });

            vm.step = 2;
        }

        vm.goToCard = function() {
            $state.go('card', {
                cardId: vm.card.cardId
            });
        }

        function calculateIfChanged(limitType) {
            var amountLabel = 'limitAmount' + limitType.type;
            var trnNoLabel = 'limitTrnNo' + limitType.type;
            limitType.changed = vm.initialValue[amountLabel] != vm.card[amountLabel] || vm.initialValue[trnNoLabel] != vm.card[trnNoLabel];
        }

        function init() {
            CardsService.getById($stateParams.cardId).then(function(data) {
                // We need 2 distinct copies in memory
                vm.initialValue = Object.assign({}, data);
                vm.card = Object.assign({}, data);
                vm.card.isBlocked = vm.card.cardStatus == 'Blocked'
                vm.initialValue.isBlocked = vm.card.isBlocked;
            });
        }

        init();
    }
}());